export default [
  { gender: 'She/hers/her', value: 'F' },
  { gender: 'He/his/him', value: 'M' },
  { gender: 'Name only', value: 'N2' },
  { gender: 'They/theirs/them', value: 'N1' },
  { gender: 'Zie/zirs/zim', value: 'N3' },
  { gender: 'Ey/eirs/em', value: 'N4' },
]
